import React from 'react'
import { Link } from 'react-router-dom'
import './About.css'
import Details from './details/Details'
import Experiences from './Experiences/Experiences'
export default function About(props) {
    const css = {
        "--background": `${props.isValue ? props.mode : 'red'}`
    }
    return (
        <>
            <div className="bodyCon bodyHome bodyAbout">
                <div className="bodyComponent projectComponent">
                    <div className="aboutContent">

                        <div className="aboutHeading" style={css} >
                            <h1>About Me</h1>
                        </div>
                        <div className="aboutMe">
                            <h2><span>I'm sahil khan and</span>
                                <span className='red' style={{ color: `${props.isValue ? props.mode : 'red'}` }}>Web Developer</span>
                            </h2>
                            <p>As a front-end web developer, I am responsible for the design and development of the user interface for web applications. This includes creating visually appealing layouts, ensuring a seamless user experience, and developing responsive and mobile-friendly designs.

                                I am proficient in HTML, CSS, and JavaScript, and have a strong understanding of front-end frameworks such as Bootstrap and React. I also have experience with version control systems like Git, and am familiar with agile development methodologies.

                                In my previous roles, I have successfully developed and maintained a number of web applications, collaborating with cross-functional teams and taking projects from conception to deployment. I am skilled at analyzing user needs and using my technical expertise to deliver effective solutions.

                                I am excited to bring my skills and experience to a new role as a front-end web developer, and am eager to continue learning and growing in this field.</p>
                        </div>
                        <div className='detail'>
                            <div className="detailDiv">
                                <Details Heading='Birthday' p='10 oct 2001' />
                                <Details Heading='Age' p='21' />
                                <Details Heading='Website' p='https://zer-0ne.github.io/zer0ne' />
                                <Details Heading='Email' p='sahilkhan8294799@gmail.com' />
                                <Details Heading='Degree' p='Computer Science' />
                                <Details Heading='Phone' p='+91 7982408995' />
                                <Details Heading='City' p='Ghaziabad' />
                                <Details Heading='Freelance' p='Available' />
                            </div>
                            <div className="ex">
                                <Experiences style={{ backgroundColor: `${props.isValue ? props.mode : null}`, width: '95%' }} head='HTML' />
                                <Experiences style={{ backgroundColor: `${props.isValue ? props.mode : null}`, width: '90%' }} head='CSS' />
                                <Experiences style={{ backgroundColor: `${props.isValue ? props.mode : null}`, width: '80%' }} head='JS' />
                                <Experiences style={{ backgroundColor: `${props.isValue ? props.mode : null}`, width: '90%' }} head='REACT JS' />
                                <Experiences style={{ backgroundColor: `${props.isValue ? props.mode : null}`, width: '70%' }} head='NODE JS' />
                                <Experiences style={{ backgroundColor: `${props.isValue ? props.mode : null}`, width: '80%' }} head='PYTHON' />
                            </div>
                        </div>
                        <Link to='/project'>
                            <button className='btn' style={{ backgroundColor: `${props.isValue ? props.mode : "red"}` }}>Projects</button>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}
